import Navbar from '../../../../components/Navbar'
import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { useForm } from 'react-hook-form';
import useAxiosPrivate from '../../../../hooks/useAxiosPrivate';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';


export default function CreateCountry() {
    const axiosPrivate = useAxiosPrivate();
    const { register, handleSubmit, formState: { errors }, setValue, watch } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [flag, setFlag] = useState(null);

    const postData = async (data) => {
        const makeData = {
            name: data.name,
            code: data.code,
            currency_code: data.currency_code,
            phone_prefix: data.phone_prefix,
            language: data.language,
            app_language: data.app_language,
            symbol: data.symbol,
            is_shipment: data.is_shipment,
            decimal_digits: data.decimal_digits,
            thousand_separator: data.thousand_separator,
            flag: flag,
            maxLength: data.maxLength,
            minLength: data.minLength,
            fraction_separator: ",",
            symbol_spacing: 1,
            is_def_based_currency: 1,
            exchange_rate: 0

        }
        const response = axiosPrivate.post('country/create', makeData);
        return response;
    }

    const { mutate } = useMutation(postData, {
        onSuccess: (successData) => {
            if (successData?.data?.success) {
                setTimeout(() => {
                    window.location.href = '/admin/dashboard/countries'
                }, 3000)
            }
        },
        onError: (error) => {
            setIsLoading(false)
        }
    })

    const handleFile = (event) => {
        const imageFile = event?.target?.files[0];

        if (imageFile.size > 1000000) {
            alert("File size should be less than 1MB");
            return;
        }
        const reader = new FileReader();


        reader.readAsDataURL(imageFile);
        reader.onload = () => {
            setFlag(reader?.result);
        };
    }


    const onSubmit = (data) => {
        setIsLoading(true);
        mutate(data);
    }
    return (
        <>
            <Navbar
                title="Create a Country"
            />
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className='container my-5'>
                    <div className='card'>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField
                                    id="name"
                                    label="Name"
                                    variant="outlined"
                                    placeholder="Enter Country Name"
                                    fullWidth={true}
                                    margin="normal"
                                    {...register("name")}
                                    error={!!errors?.name}
                                    helperText={errors.name?.message}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    id="code"
                                    label="code"
                                    variant="outlined"
                                    placeholder="Enter code"
                                    fullWidth={true}
                                    margin="normal"
                                    {...register("code")}
                                    error={Boolean(errors?.code)}
                                    helperText={errors.code ? errors.code?.message : ""}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    id="currency_code"
                                    label="Currency code"
                                    variant="outlined"
                                    placeholder="Enter Currency code"
                                    fullWidth={true}
                                    margin="normal"
                                    {...register("currency_code")}
                                    error={Boolean(errors?.currency_code)}
                                    helperText={errors.currency_code ? errors.currency_code?.message : ""}
                                />

                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    id="phone_prefix"
                                    label="Phone Prefix"
                                    variant="outlined"
                                    placeholder="Enter Phone Prefix"
                                    margin="normal"
                                    fullWidth={true}
                                    {...register("phone_prefix")}
                                    error={Boolean(errors?.phone_prefix)}
                                    helperText={errors.phone_prefix ? errors.phone_prefix?.message : ""}
                                />

                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    id="maxLength"
                                    label="Phone Number Max Length"
                                    variant="outlined"
                                    placeholder="Phone Number Max Length"
                                    fullWidth={true}
                                    margin="normal"
                                    {...register("maxLength")}
                                    error={Boolean(errors?.maxLength)}
                                    helperText={errors.maxLength ? errors.maxLength?.message : ""}
                                />

                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    id="minLength"
                                    label="Phone Number Min Length"
                                    variant="outlined"
                                    placeholder="Phone Number Min Length"
                                    fullWidth={true}
                                    margin="normal"
                                    {...register("minLength")}
                                    error={Boolean(errors?.minLength)}
                                    helperText={errors.minLength ? errors.minLength?.message : ""}
                                />

                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    id="language"
                                    label="Language"
                                    variant="outlined"
                                    placeholder="Enter Language"
                                    fullWidth={true}
                                    margin="normal"
                                    {...register("language")}
                                    error={Boolean(errors?.language)}
                                    helperText={errors.language ? errors.language?.message : ""}
                                />

                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth={true} sx={{ marginY: '16px' }}>
                                    <InputLabel id="demo-simple-select-label">App Language</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="type"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        {...register("app_language")}
                                        value={watch("app_language") || ""}
                                        label="Order Type"
                                        onChange={(event) => {
                                            setValue("app_language", event.target.value)
                                        }}
                                    >
                                        <MenuItem value="en">English</MenuItem>
                                        <MenuItem value="da">Danish</MenuItem>
                                    </Select> </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth={true} sx={{ marginY: '16px' }}>
                                    <InputLabel id="demo-simple-select-label">Shipment Applicaple</InputLabel>
                                    <Select
                                            labelId="demo-simple-select-label"
                                            id="is_shipment"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            {...register("is_shipment")}
                                            value={watch("is_shipment") !== undefined ? watch("is_shipment") : ""}
                                            label="Shipment Applicable"
                                            onChange={(event) => {
                                                setValue("is_shipment", parseInt(event.target.value, 10));
                                            }}
                                        >
                                            <MenuItem value={1}>True</MenuItem>
                                            <MenuItem value={0}>False</MenuItem>
                                        </Select> </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    id="symbol"
                                    label="Currency Symbol"
                                    variant="outlined"
                                    placeholder="Enter symbol"
                                    margin="normal"
                                    fullWidth={true}
                                    {...register("symbol")}
                                    error={Boolean(errors?.da_text)}
                                    helperText={errors.da_text ? errors.da_text?.message : ""}
                                />

                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    id="decimal_digits"
                                    label="Decimal Digits"
                                    variant="outlined"
                                    placeholder="Decimal Digits"
                                    fullWidth={true}
                                    margin="normal"
                                    {...register("decimal_digits")}
                                    error={Boolean(errors?.decimal_digits)}
                                    helperText={errors.decimal_digits ? errors.decimal_digits?.message : ""}
                                />

                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    id="thousand_separator"
                                    label="Thousand separator"
                                    variant="outlined"
                                    placeholder="Thousand separato"
                                    fullWidth={true}
                                    margin="normal"
                                    {...register("thousand_separator")}
                                    error={Boolean(errors?.thousand_separator)}
                                    helperText={errors.thousand_separator ? errors.thousand_separator?.message : ""}
                                />

                            </Grid>
                            <Grid item xs={6}>
                                <label for="formFile" class="form-label">Upload Flag Image</label>
                                <input class="form-control" type="file" id="formFile" name="flag" accept=".png,.jpg,.jpeg" onChange={handleFile} />
                            </Grid>

                            <Grid item xs={12}>
                                <button
                                    className='btn btn-success text-white'
                                    disabled={isLoading}
                                    type="submit"
                                >Submit</button>

                            </Grid>
                        </Grid>


                    </div>

                </div>
            </form >
        </>
    )
}
